var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"cxm-Tag",class:_vm.classes},_vm.$listeners),[_vm._t("leftIcons"),_c('span',{class:_vm.textClasses},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2),_vm._t("rightIcons")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }